import { render } from "./SeedlingBeanNotEnough.vue?vue&type=template&id=77249daf&scoped=true&ts=true&lang=pug"
import script from "./SeedlingBeanNotEnough.vue?vue&type=script&lang=ts"
export * from "./SeedlingBeanNotEnough.vue?vue&type=script&lang=ts"

import "./SeedlingBeanNotEnough.vue?vue&type=style&index=0&id=77249daf&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77249daf"]])

export default __exports__